<template>
    <div>
        <div class=" row mb-2">
            <label class="col-sm-4  text-lr lh40"><i
                    v-if=" Data.data.c_priority==='S'"
                    class="fa fa-asterisk text-danger font10 ml-1"
                    aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
            <div class="col-sm-7 flex1 lh35">
                <el-input style="width: 100px" @change="pushData(Data.data.c_id,value1,1)"
                          v-model="value1"></el-input>
                <span>——</span>
                <el-input style="width: 100px" @change="pushData(Data.data.c_id,value2,2)"
                          v-model="value2"></el-input>
                <span class="ml-2">{{ Data.data.c_unit }} </span>
            </div>
        </div>


        <!--        <div v-for="(val,building_index) in itemData" :key="building_index">-->
        <!--            <el-form-item style="margin-bottom: 0" :label-width="formLabelWidth"-->
        <!--                          :label="val.name" >-->
        <!--                <el-input style="width: 100px" @change="pushData(val.id,value1,1)"-->
        <!--                          v-model="value1"></el-input>-->
        <!--                <span>——</span>-->
        <!--                <el-input style="width: 100px" @change="pushData(val.id,value2,2)"-->
        <!--                          v-model="value2"></el-input>-->
        <!--                    绿-->
        <!--                <el-button style="margin: 0 8px;padding: 3px" :type="checkType(val.id)"-->
        <!--                           :icon="checkIcon(val.id)" circle v-if="val.id.toString().substr(0, 1)==='6'-->
        <!--                      ||val.id.toString().substr(0, 1)==='7'||val.id.toString().substr(0, 1)==='8'"-->
        <!--                           @click="select(building_index,val.id,val.name)" :ref="'check'+building_index"></el-button>-->
        <!--                <span v-if="val.id.toString().substr(0, 1)==='6'-->
        <!--                      ||val.id.toString().substr(0, 1)==='7'||val.id.toString().substr(0, 1)==='8'">(是否上传该字段)</span>-->
        <!--                <i class="el-icon-circle-plus-outline" style="margin: 0 15px"-->
        <!--                   @click="add()" v-show="val.type==='Numrs'"></i>-->
        <!--                <i class="el-icon-remove-outline" style="margin: 0 15px"-->
        <!--                   v-if="val.name===''"-->
        <!--                   @click="min(building_index)"></i>-->
        <!--            </el-form-item>-->
    </div>
    <!--    </div>-->
</template>

<script>

export default {
    name: "test",
    filters: {},
    computed: {},
    props: [
        'Data'
    ],
    data() {
        return {
            requiredIdList: this.$store.state.requiredIdList,
            btn_flag: false,
            formLabelWidth: '200px',
            // 子组件向父组件传的数据
            // returnData: [],
            //父组件传过来的数据
            // itemData: [],
            value1: '',
            value2: '',
            value: this.Data.data.c_value === null ? [] : this.Data.data.c_value,
        };
    },
    created() {
        console.log(this.Data, 'dg45')
        // this.dealData()
    },
    methods: {
        //将数据提交到store，失去焦点时触发
        pushData(id, v, flag) {
            console.log(id, v, flag, 909090)
            if (flag === 1) {
                this.value[0] = v
                console.log(this.value)
            } else {
                this.value[1] = v
                console.log(this.value)
            }
            this.$get_function(this.Data, this.value)

        },
        // 处理父组件传过来的数据
        dealData() {
            for (let i in this.Data) {
                if (this.Data[i].type === 'Numr' || this.Data[i].type === 'Numrs') {
                    if (this.Data[i].value !== null) {
                        let temp = this.Data[i].value.split(',')
                        this.value1 = this.Data[i].value1 = temp[0]
                        this.value2 = this.Data[i].value2 = temp[1]
                        this.itemData.push(this.Data[i])
                        console.log(this.itemData)
                        this.returnData.push({'id': this.Data[i].id, 'value': this.Data[i].value})
                    } else {
                        this.Data[i].value1 = ''
                        this.Data[i].value2 = ''
                        this.itemData.push(this.Data[i])
                    }
                }
            }
            this.$store.commit('getInputRangedata', this.returnData)
        },
        // checkIcon(id) {
        //     for (let i in this.requiredIdList) {
        //         if (this.requiredIdList[i].id === id) {
        //             return 'el-icon-check'
        //         }
        //     }
        //     return 'el-icon-close'
        // },
        // checkType(id) {
        //     for (let i in this.requiredIdList) {
        //         if (this.requiredIdList[i].id === id) {
        //             return 'success'
        //         }
        //     }
        //     return 'info'
        // },
        // select(building_index, id, name) {
        //     console.log(this.$refs['check' + building_index][0].icon, id)
        //     if (this.$refs['check' + building_index][0].icon === 'el-icon-close') {
        //         this.requiredIdList.push({'id': id, 'name': name})
        //         // this.$refs['check'+building_index][0].icon='el-icon-check'
        //     } else {
        //
        //         for (let i in this.requiredIdList) {
        //             if (this.requiredIdList[i].id === id) {
        //                 this.requiredIdList.splice(i, 1)
        //                 break
        //             }
        //         }
        //         // this.$refs['check'+building_index][0].icon='el-icon-close'
        //     }
        //     // this.btn_flag=!this.btn_flag
        //     this.$store.commit('getrequiredIdList', this.requiredIdList)
        //     console.log(this.requiredIdList)
        // },

        // add() {
        //     this.modules.push({
        //         value1: '',
        //         value2: ''
        //     });
        // },
        // min(i) {
        //     this.modules.splice(i, 1);
        // }
    },
    mounted() {
    }
};
</script>

<style scoped>

</style>

